import React from "react";
import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import styles from "./SyncSchedulePanel.module.scss";

interface IActionButtonsProps {
  hasAnyChanges: boolean;
  hasChanges: boolean;
  saving: boolean;
  onReset: () => void;
  onResetAll: () => void;
  onSave: () => void;
}

const ActionButtons: React.FC<IActionButtonsProps> = ({
  hasAnyChanges,
  hasChanges,
  saving,
  onReset,
  onResetAll,
  onSave
}) => {
  if (!hasAnyChanges) {
    return null;
  }

  return (
    <div className={styles.actionButtons}>
      {hasChanges && (
        <Button
          onClick={onReset}
          disabled={saving}
          icon={IconNames.RESET}
        >
          Reset This Schedule
        </Button>
      )}
      <Button
        onClick={onResetAll}
        disabled={saving}
        icon={IconNames.RESET}
      >
        Reset All Schedules
      </Button>
      <Button
        intent={Intent.PRIMARY}
        onClick={onSave}
        disabled={saving}
        icon={saving ? undefined : IconNames.FLOPPY_DISK}
        loading={saving}
      >
        {saving ? 'Saving...' : 'Save All Changes'}
      </Button>
    </div>
  );
};

export default ActionButtons;
